import React, { useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation.js";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection.jsx";
import NoteTable from "../../common_nextgen/common_components/NoteScreenComponents/NoteTable.jsx";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator.js";
import useOutOfPocketMaxScheduleNote from "./hooks/useOutOfPocketMaxScheduleNote.js";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";

const OutOfPocketMaxScheduleNote = () => {
  const location = useLocation();
  //const { selectedPriceSchedules, currentMode, currentIndex: initialIndex = 0,deccription } = location.state || {};
  const { state: stateVal } = location;
  const { axios_helper_no_header } = useAxios();
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log(
    "states",
    stateVal,
    currentState,
    selectedSchedules,
    initialIndex,
    previousState
  );
  const navigateToPage = useCustomNavigate();

  const {
    notes,
    newNotes,
    mode,
    first,
    rows,
    totalRecords,
    currentIndex,
    setMode,
    setCurrentIndex,
    handleSaveNotes,
    handleChangeNewNote,
    onPageChange,
    exportAsCSV,
  } = useOutOfPocketMaxScheduleNote(selectedSchedules, initialIndex);

  const screen_title = "Out Of Pocket Max Schedule Note";
  const screen_code = "RCOPN001";

  const columns = useMemo(
    () =>
      mode === "view"
        ? [
            { key: "opnNote", header: "Note" },
            { key: "chgDate", header: "Added Date" },
            { key: "chgTime", header: "Added Time" },
            { key: "chgUserName", header: "User" },
          ]
        : [{ key: "opnNote", header: "Note" }],
    [mode]
  );

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);

  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);

  const handleModeSwitch = useCallback(() => {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }, [mode]);

  const leftButtons = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: handleBackAndSetMode,
        button_key: "F12",
      },
      ...(mode === "add"
        ? [
            {
              button_label: "View Note",
              button_handeler: handleModeSwitch,
              button_key: "F9",
            },
          ]
        : []),
    ],
    [mode, handleBackAndSetMode, handleModeSwitch]
  );

  const rightButtons = useMemo(
    () => [
      ...(mode === "view"
        ? [
            {
              button_label: "Add Note",
              button_handeler: handleModeSwitch,
              button_key: "F9",
            },
          ]
        : []),
      { button_label: "Export as CSV", button_handeler: exportAsCSV },
    ],
    [mode]
  );

  const getName = (selectedSchedules, currentIndex) => (
    <>
      <strong>Schedule </strong>
      {selectedSchedules[currentIndex].opcScheduleName}
      <span className="info-records">
        <strong>Description </strong>
        {selectedSchedules[currentIndex].opcDescription}
      </span>
    </>
  );

  return (
    <div className="container">
      <ButtonsSection ctaButtons={leftButtons} align="left" />
      <div className="left-aligned-section">
        <div className="header-section">
          <h1>
            {screen_title} - <span className="heading-cod">{screen_code}</span>
          </h1>
        </div>
        <p className="head-name">{getName(selectedSchedules, currentIndex)}</p>
      </div>
      <div className="button-sections">
        <ButtonsSection ctaButtons={rightButtons} align="right" />
      </div>
      <NoteTable
        data={notes}
        columns={columns}
        mode={mode}
        newNotes={newNotes}
        handleChangeNewNote={handleChangeNewNote}
        handleSaveNotes={handleSaveNotes}
      />
      <NextGenPaginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        currentPage={first / rows}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default OutOfPocketMaxScheduleNote;
